module.exports = __webpack_public_path__ + "img/jad-primary.26db50f1.svg";